import React, { useEffect, useState } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import AddNewUnit from "features/adicionar-unidade/components/AdicionarUnidadePage";
import Adesao from "features/adesao/components/AdesaoPage";
import AdesaoEmail from "features/adesao-email/components/AdesaoEmailPage";
import AlterarSenha from "features/alterar-senha/AlterarSenhaPage";
import BoletoRapido from "features/boleto-rapido";
import Boletos from "features/boletos";
import Consumo from "features/consumo";
import DebitoAutomatico from "features/debito-automatico";
import EsqueciSenhaMI from "features/forgot-password-mi/components/ForgotPasswordMiPage";
import FaleConoscoMi from "features/fale-conosco";
import Login from "features/login/components/LoginPage";
import MFARegister from "components/layout/home/MFARegister";
import MeusDados from "features/meus-dados";
import Pesquisa from "features/pesquisa";
import Portal from "features/portal/components/PortalPage";
import PreferenciaCobranca from "features/preferencia-cobranca";
import PrimeiroAcesso from "features/first-access/components/FirstAccessPage";
import Profile from "features/profile";
import Religue from "features/religue";
import RetornarUnidade from "features/retornar-unidade/components/RetornarUnidadePage";
import TrocaTitularidade from "features/troca-titularidade/components/TrocaTitularidadePage";
import UltragazEnergia from "features/ultragaz-energia";
import UltragazEnergiaSucesso from "features/ultragaz-energia-sucesso";
import VerificarEmail from "features/verificar-email/components/VerifyEmailPage";
import { useAuth } from "hooks/authHook";

type RouteProps = {
  path: string;
  Component: JSX.Element;
};

const Routes = (): JSX.Element => {
  const { userData } = useAuth();

  const PublicRoutes = [
    { path: "/", Component: Login },
    { path: "/acessar", Component: Login },
    { path: "/validar-token", Component: MFARegister },
    { path: "/primeiro-acesso-mi", Component: PrimeiroAcesso },
    { path: "/troca-titularidade", Component: TrocaTitularidade },
    { path: "/esqueci-senha-mi", Component: EsqueciSenhaMI },
    { path: "/adesao", Component: Adesao },
    { path: "/adesao/confirmacao-email", Component: AdesaoEmail },
    { path: "/verificar-email", Component: VerificarEmail },
    { path: "/boleto-rapido", Component: BoletoRapido },
  ];

  const MIRoutes = [
    { path: "/portal", Component: Portal },
    { path: "/consulta-debitos", Component: Boletos },
    { path: "/adicionar-unidade", Component: AddNewUnit },
    { path: "/retornar-unidade", Component: RetornarUnidade },
    { path: "/religue", Component: Religue },
    { path: "/consumo", Component: Consumo },
    { path: "/meus-dados", Component: MeusDados },
    { path: "/meus-dados-novo", Component: Profile },
    { path: "/alterar-senha", Component: AlterarSenha },
    { path: "/fale-conosco", Component: FaleConoscoMi },
    { path: "/pesquisa", Component: Pesquisa },
    { path: "/debito-automatico", Component: DebitoAutomatico },
    { path: "/preferencia-cobranca", Component: PreferenciaCobranca },
    { path: "/ultragaz-energia", Component: UltragazEnergia },
    { path: "/ultragaz-energia/sucesso", Component: UltragazEnergiaSucesso },
  ];

  const customerType =
    userData.customerType ||
    localStorage.getItem("@UltragazEmpresarial:customerType");
  const hasAccessToken =
    userData.accessToken ||
    localStorage.getItem("@UltragazEmpresarial:accessToken");
  const hasRefreshToken =
    userData.refreshToken ||
    localStorage.getItem("@UltragazEmpresarial:refreshToken");

  const buildRoutes = (
    customerType,
    hasAccessToken,
    hasRefreshToken
  ): RouteProps[] => {
    let initalRoute = [];
    if (customerType === "MI" && hasAccessToken && hasRefreshToken) {
      initalRoute = [...PublicRoutes, ...MIRoutes];
    } else {
      initalRoute = PublicRoutes;
    }
    return initalRoute;
  };

  const [routes, setRoutes] = useState(
    buildRoutes(customerType, hasAccessToken, hasRefreshToken)
  );

  useEffect(() => {
    const customerType =
      userData.customerType ||
      localStorage.getItem("@UltragazEmpresarial:customerType");
    const hasAccessToken =
      userData.accessToken ||
      localStorage.getItem("@UltragazEmpresarial:accessToken");
    const hasRefreshToken =
      userData.refreshToken ||
      localStorage.getItem("@UltragazEmpresarial:refreshToken");
    setRoutes(buildRoutes(customerType, hasAccessToken, hasRefreshToken));
  }, [userData, setRoutes]);

  const moreProps = (path, Component, props): JSX.Element => {
    switch (path) {
      case "/redefinir-senha":
        return <Component {...props} step={3} />;
      default:
        return <Component {...props} />;
    }
  };

  return (
    <BrowserRouter>
      <Switch>
        {routes.map(({ Component, ...route }) => (
          <Route
            exact
            key={route.path}
            path={route.path}
            render={(props) => moreProps(route.path, Component, props)}
          />
        ))}
        <Redirect from="*" to="/" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
